import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";
import { useAuth } from "@/lib/auth";

export const Route = createFileRoute("/_authenticated")({
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  const { user, ready } = useAuth();

  if (!ready) {
    return (
      <div className="mx-auto max-w-7xl px-6 py-24 text-muted-foreground">
        Nalagam…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/prijava" replace />;
  }

  return <Outlet />;
}
